import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["appearance", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { useAppearance, AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext';
import * as views from './LogoCarousel.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var LogoCarousel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var externalAppearance = _ref.appearance,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var appearance = useAppearance(externalAppearance);
  return _jsx(views.LogoCarousel, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: _jsx(AppearanceProvider, {
      appearance: appearance,
      children: children
    })
  }));
});